import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { JobPhaseCreatableInterface } from '../interfaces/job-phase-creatable.interface';
import { JobPhaseDto } from './job-phase.dto';

export class JobPhaseCreateDto
  extends IntersectionType(
    PickType(JobPhaseDto, ['jobId', 'phaseId']),
    PartialType(PickType(JobPhaseDto, ['notes'])),
  )
  implements JobPhaseCreatableInterface {}
